/**
 * Funnel stages offered by the "Стадия воронки" filter of the clients list.
 * One query key for the filter bar and for the stale-value check (KAN-685),
 * so the stages are fetched once. undefined: not loaded yet or failed.
 * KAN-790: the nudge ladder editor reuses it and passes `enabled` to skip the
 * request until the stages are needed.
 */
import { useQuery } from '@tanstack/react-query';
import { funnelApi } from '@/services/api/funnel';
import type { FunnelStageConfig } from '@/types/funnel';

/** Option value of a stage: `${funnel_codename}:${codename}` (codename repeats across funnels). */
export function stageOptionValue(stage: FunnelStageConfig): string {
  return `${stage.funnel_codename ?? ''}:${stage.codename}`;
}

export function useFunnelStageOptions(enabled = true): FunnelStageConfig[] | undefined {
  const { data } = useQuery({
    queryKey: ['funnel-stages'],
    queryFn: () => funnelApi.listStages(),
    retry: false,
    enabled,
  });
  return data;
}
